/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import defaultRequest from "./v1";
export default defaultRequest;

export { tableRequest } from "./v1";
export { versionsApi } from "./v1/versionsApi";
export { notesApi } from "./v1/notesApi";
export { shotsApi } from "./v1/shotsApi";
